export default __webpack_public_path__ + "static/media/skovstykket-tenancy-15.424a419b.jpg";